import * as firebase        from 'firebase/app';

import * as ping from '@/lib/usage_ping';

const urls = {
    "quizMe.dev": "http://localhost/finishSignup",
    "quizMe.prod": "https://app.getquizme.com/finishSignup"
}

function emailAuth(email: string) {
    
  const actionCodeSettings = {
      url: urls[window["DD_SERVICE_NAME"]],
      handleCodeInApp: true,
      iOS: {
        bundleId: 'com.example.ios'
      },
      android: {
        packageName: 'com.example.android',
        installApp: true,
        minimumVersion: '12'
      },
      dynamicLinkDomain: 'app.getquizme.com'
  };

  return firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
}

export default emailAuth;